import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import { Datagrid, EditButton, List, ListActions, NumberField, ShowButton, SimpleList, TextField } from "react-admin";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListSports = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Спорт"
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageSports)} />}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={() => (
            <div>
              <MobileListRow fields={[{ label: "Име на български език", value: <TextField source="nameBg" /> }]} />
              <MobileListRow fields={[{ label: "Име на английски език", value: <TextField source="nameEn" /> }]} />
            </div>
          )}
          secondaryText={() => (
            <MobileListRow
              fields={[{ label: "Капацитет студенти", value: <NumberField source="studentsCapacity" /> }]}
            />
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageSports}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPrevieSports}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <NumberField
            source="studentsCapacity"
            label="Капацитет студенти"
          />
          <SecuredComponent permission={permissions.canManageSports}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPrevieSports}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListSports;
